import { useState } from "react";
import { horizonsSelectionnables } from "../utils/horizon";

/**
 * Gère le select "Année"/"Réchauffement" de la sidebar.
 *
 * Un <select> renvoie toujours e.target.value en STRING, même pour une
 * <option value={2050}>. Comparer cette string aux horizons "classiques"
 * (des NOMBRES : 2035, 2050) avec .includes() échoue toujours, donc le choix
 * de l'utilisateur ne prenait jamais et retombait sur le premier horizon.
 * setHorizon retype systématiquement la valeur brute du select contre la
 * liste des horizons possibles, une bonne fois pour toutes ici plutôt que
 * dans chaque page.
 */
export function useHorizon(scenario, options) {
  const { indexParDefaut = 0, ...optionsHorizons } = options ?? {};
  const possibles = horizonsSelectionnables(scenario, optionsHorizons);
  const [horizonChoisi, setHorizonChoisi] = useState(
    possibles[indexParDefaut] ?? possibles[0]
  );

  const horizon =
    possibles.find((h) => String(h) === String(horizonChoisi)) ??
    possibles[indexParDefaut] ??
    possibles[0];

  const setHorizon = (valeurBrute) => {
    const trouve = possibles.find((h) => String(h) === String(valeurBrute));
    setHorizonChoisi(trouve ?? valeurBrute);
  };

  return [horizon, setHorizon, possibles];
}
